<template>
  <div>
    <notifications
      position="top right"
      closeOnClick
      classes="my-notification"
    />
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      loading: false,
    };
  },
  created() {
    this.$bus.$on("checkLTR", (country, isGPT = false) => {
      this.checkLTR(country, isGPT);
    });
  },
  mounted() {
    const vm = this;
    window.addEventListener("online", function() {
      vm.$store.commit("global/setInternetStatus", "online");
      vm.$store.dispatch("customer/GetClientChatAllMessage");
    });
    window.addEventListener("offline", function() {
      vm.$store.commit("global/setInternetStatus", "offline");
    });

    if (!navigator.onLine) {
      vm.$store.commit("global/setInternetStatus", "offline");
    }
  },
  methods: {
    checkLTR(country, isGPT = false) {
      const rtlCountries = ["IL", "SA", "SA-AR"];
      const dir = rtlCountries.includes(country) ? "rtl" : "ltr";
      let dom = isGPT
        ? document.querySelector(".gpt")
        : document.documentElement;

      if (rtlCountries.includes(country)) {
        dom.classList.remove("ltr");
        dom.classList.add("rtl");
      } else {
        dom.classList.remove("rtl");
        dom.classList.add("ltr");
      }

      dom.setAttribute("dir", dir);
      dom.style.setProperty("--direction", dir);
      this.$store.commit("global/setDir", dir);
    },
  },
  computed: {
    customerSurvey() {
      return this.$store.getters["global/customerSurvey"];
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/all.scss";
</style>
